module.exports = __webpack_public_path__ + "media/site/images/carousel_slides/carousel-slide-intro-factories-bg-eabca4f8548e02a7a68194c679d0c350.png";